import { h, type Component, type VNodeChild } from 'vue';
import type { FormatterFactory } from '../types';

export const checkbox: FormatterFactory = () => {
  const renderer = (props: { value: any }): VNodeChild =>
    h('input', {
      type: 'checkbox',
      class: 'itp-data-grid__checkbox',
      checked: !!props.value,
      onClick: (event: Event) => event.preventDefault(),
    });

  renderer.props = ['value'];

  return {
    component: renderer as Component,
    toText: (value) => (value == null ? '' : String(value)),
  };
};
